export default {
  "category.title": "视频分类",
  "category.subtitle": "按分类浏览您感兴趣的视频内容",
  "category.all": "全部",
  "category.movie": "电影",
  "category.tv": "电视剧",
  "category.variety": "综艺",
  "category.anime": "动漫",
  "category.documentary": "纪录片",
  "category.kids": "少儿",
  "category.sports": "体育",
  "category.music": "音乐",
  "category.sort.latest": "最新发布",
  "category.sort.popular": "最受欢迎",
  "category.sort.rating": "评分最高",
  "category.noResults": "该分类暂无内容",
  "category.watchNow": "立即观看",
  "category.vip": "VIP",
  "category.free": "免费",
};